import styled from "@emotion/styled";
import { css } from "@emotion/react";
import * as theme from "@gumtree/ui-library/src/base/theme";

export const ToggleContainer = styled.div<{ open: boolean; dropdown: boolean; isMobile: boolean }>`
    grid-column: make-offer;

    button:first-of-type {
        display: flex;
        justify-content: center;

        .toggle {
            transform: ${({ open, dropdown }) => open && !dropdown && "rotateX(180deg)"};
        }
    }
`;

export const Root = styled.div<{ dropdown: boolean }>`
    grid-column: span 2; /** For mobile view ContactButtons */

    div.panel {
        ${({ dropdown }) =>
            dropdown &&
            css`
                position: fixed;
                background: ${theme.colors.white};
                right: 12px;
                top: 95px;

                ${theme.mediaQuery.from(theme.breakpoints.medium)} {
                    top: 68px;
                }
            `}
    }

    fieldset[name="provide-offer"],
    fieldset[name="provide-offer-response"] {
        border: 0;
        margin: 0;
        padding: 0;
    }

    fieldset[name="provide-offer"] {
        legend {
            display: none;
        }
    }

    fieldset[name="provide-offer-response"] {
        > div {
            margin-top: ${theme.gutterSizes.small};
        }

        p {
            margin-top: 0;
        }
    }
`;

export const Price = styled.div`
    display: grid;
    grid-template-columns: 33% 66%;

    font-size: ${theme.fontSizes.large};
    margin-bottom: ${theme.gutterSizes.medium};

    .sub-text {
        font-size: ${theme.fontSizes.small};
    }
`;

export const Offer = styled.div<{ error: boolean }>`
    display: grid;
    grid-template-columns: 33% 66%;
    grid-template-areas:
        "label input"
        "error error"
        "submit submit";

    > div:first-of-type {
        grid-area: label;

        label {
            padding-left: 8px;
        }
    }

    > div:nth-of-type(2) {
        grid-area: input;
        position: relative;

        &:before {
            position: absolute;
            top: 12px;
            left: 10px;
            z-index: 2;
            pointer-events: none;
            content: "£";
        }

        input {
            position: relative;
            z-index: 1;
            padding-left: 22px;
        }

        .input-clear {
            z-index: 1;
        }

        button {
            align-items: center;
        }
    }

    > div:nth-of-type(3) {
        display: ${({ error }) => (error ? "block" : "none")};
        grid-area: error;
        color: red;
        margin-top: ${theme.gutterSizes.small};
    }

    > button:nth-of-type(1) {
        /* stylelint-disable-line */
        margin-top: ${theme.gutterSizes.medium};
        grid-area: submit;
    }
`;
